module.exports = __webpack_public_path__ + "assets/img/array1.85d0c442.svg";